// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"2994ef18","492":"f7e5b6d7","587":"bec2332f"}[chunkId] + ".chunk.css";
};